import { render, staticRenderFns } from "./DniTramiteInput.vue?vue&type=template&id=3e058dcb"
import script from "./DniTramiteInput.vue?vue&type=script&lang=js"
export * from "./DniTramiteInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports